import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useRouteMatch, generatePath } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import GameRankItem from './RankItem/GameRankItem';
import { setGameError, getGameRankTabList } from '../../../actions/game';
import styles from './GameRank.module.less';
import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import Loading from '../../../components/Loading/Loading';

const selectGameInfo = createSelector(
  state => state.game,
  game => ({
    rankTabList: game.rankTabList,
    error: game.error,
  }),
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function GameRank({ source, scrollAdv }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { code } = useParams();
  const { rankTabList = [], error } = useSelector(selectGameInfo);
  const logInfoData = useSelector(selectLogInfo);
  const [initTime, setInitTime] = useState(Date.now());

  const getPVLog = () => {
    dispatch(
      logging({
        category: 'P',
        action: source,
        label: '',
        param2: {
          source: code ? `${source}||${code}` : source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: code ? `${source}||${code}` : source,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  const getUVlog = () => {
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime: initTime,
          leaveTime: Date.now(),
          time: Math.ceil(Date.now() - initTime),
        },
      }),
    );
  };

  useEffect(() => {
    getPVLog();
    setInitTime(Date.now());
  }, []);
  useActivate(() => {
    getPVLog();
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    getUVlog();
  });

  useEffect(() => {
    setInitTime(Date.now());
    if (!rankTabList || rankTabList.length < 1) {
      dispatch(getGameRankTabList());
    }
  }, []);
  useActivate(() => {
    setInitTime(Date.now());
    if (!rankTabList || rankTabList.length < 1) {
      dispatch(getGameRankTabList());
    }
  });
  // useEffect(() => {
  //   if (
  //     rankTabList &&
  //     rankTabList.length > 0 &&
  //     code !== undefined &&
  //     !rankTabList.some(rank => rank.code === code)
  //   ) {
  //     history.replace(generatePath(path, { code: rankTabList[0].code }));
  //   }
  // }, [rankTabList]);

  useEffect(() => {
    if (error) {
      setGameError(false);
      history.replace(`${CONTEXT}/game999999?sourcePage=Game`);
    }
  }, [error]);

  return (
    <div
      className={styles.page}
      data-source={source}
      pagescroll="PCStore_Page_Scroll"
      onScroll={e => {
        if (scrollAdv && typeof scrollAdv === 'function') {
          let adcInView = sessionStorage.getItem('Game_Adv_Is_Show');
          if (e?.target?.scrollTop > 0 && adcInView) {
            scrollAdv();
            e.target.scrollTop = 0;
          }
        }
      }}
    >
      <div className={styles.page_container}>
        <div>
          {rankTabList.length > 0 && (
            <div className={styles.game_rank}>
              {rankTabList.map((tab, index) => (
                <GameRankItem
                  key={index}
                  indexKey={index}
                  rankInfo={tab}
                  logInfo={{
                    clTag: 'Game',
                    tag: 'Game_Rank',
                    ...logInfoData,
                  }}
                />
              ))}
            </div>
          )}
        </div>
        {rankTabList.length <= 0 && (
          <div className={styles.loading}>
            <Loading styleType={'black'} />
          </div>
        )}
      </div>
    </div>
  );
}

export default props => {
  return (
    <KeepAlive id={`game${props.code}`} name={`game${props.code}`} saveScrollPosition="screen">
      <GameRank {...props} />
    </KeepAlive>
  );
};
